import React from 'react';

export type PracticeInterviewType = 'mock_ai' | 'coding' | 'group_discussion';

interface PracticeInterviewTypePickerProps {
  selectedType: PracticeInterviewType | null;
  onSelect: (type: PracticeInterviewType) => void;
  onSettingsClick?: () => void;
}

const PracticeInterviewTypePicker: React.FC<PracticeInterviewTypePickerProps> = ({
  selectedType,
  onSelect,
  onSettingsClick,
}) => {

  return (
    <div className="form-section" style={{ marginBottom: '16px' }}>
      <div className="checks-header">
        <label className="input-label">Choose Interview Type</label>
        <button
          type="button"
          className="interview-settings-link"
          onClick={onSettingsClick}
        >
          Change interview settings
        </button>
      </div>
      <div className="type-options">
        <button
          type="button"
          onClick={() => onSelect('mock_ai')}
          className={`type-card ${selectedType === 'mock_ai' ? 'selected' : ''}`}
          title="Mock AI interview"
        >
          <div className="type-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 8V4H8" />
              <rect x="4" y="8" width="16" height="12" rx="2" />
              <circle cx="9" cy="13" r="1" fill="currentColor" />
              <circle cx="15" cy="13" r="1" fill="currentColor" />
              <path d="M9 17h6" />
            </svg>
          </div>
          <div className="type-content">
            <div className="type-title">Mock Interview</div>
            <div className="type-desc">Q&A with AI</div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => onSelect('coding')}
          className={`type-card ${selectedType === 'coding' ? 'selected' : ''}`}
          title="Coding interview"
        >
          <div className="type-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="16 18 22 12 16 6" />
              <polyline points="8 6 2 12 8 18" />
              <line x1="14" y1="4" x2="10" y2="20" />
            </svg>
          </div>
          <div className="type-content">
            <div className="type-title">Coding</div>
            <div className="type-desc">Live coding tasks</div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => onSelect('group_discussion')}
          className={`type-card ${selectedType === 'group_discussion' ? 'selected' : ''}`}
          title="Group Discussion"
        >
          <div className="type-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="type-content">
            <div className="type-title">Group Discussion</div>
            <div className="type-desc">Team discussion</div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default PracticeInterviewTypePicker;
